module.exports = __webpack_public_path__ + "static/jen-eeaf3d63e6f589af2b4db6d4cfec0318.jpg";